import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c4bbfb6e&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&id=c4bbfb6e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bbfb6e",
  null
  
)

export default component.exports